module.exports = __webpack_public_path__ + "img/01 wint.0cceab88.png";